import store from '../store/index'
let formatter = require('./Formatter')

let isTrue = formatter.FormatterUtils.methods.isTrue
export const SettingsUtils = {
  methods: {
    overwriteGraphSettings (settings) {
      if (settings['hide_account_setup_insurance_on_sitecodes'] !== undefined) {
        store.state.configs.HIDE_ACCOUNT_SETUP_INSURANCE_ON_SITECODES = isTrue(settings['hide_account_setup_insurance_on_sitecodes'])
      }
      if (settings['validate_insurance_with_api'] !== undefined) {
        store.state.configs.VALIDATE_INSURANCE_WITH_API = isTrue(settings['validate_insurance_with_api'])
      }
      if (settings['hide_self_completed_fields'] !== undefined) {
        store.state.configs.HIDE_SELF_COMPLETED_FIELDS = isTrue(settings['hide_self_completed_fields'])
      }
      if (settings['display_international_check'] !== undefined) {
        store.state.configs.DISPLAY_INTERNATIONAL_CHECK = isTrue(settings['display_international_check'])
      }
      if (settings['validate_kit_number_by_inventory'] !== undefined) {
        store.state.configs.VALIDATE_KIT_NUMBER_BY_INVENTORY = isTrue(settings['validate_kit_number_by_inventory'])
      }
      if (settings['allow_above_medication_text'] !== undefined) {
        store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT = isTrue(settings['allow_above_medication_text'])
      }
      if (settings['allow_consent'] !== undefined) {
        store.state.configs.ALLOW_CONSENT = isTrue(settings['allow_consent'])
      }
      if (settings['allow_checkbox_consent'] !== undefined) {
        store.state.configs.ALLOW_CHECKBOX_CONSENT = isTrue(settings['allow_checkbox_consent'])
      }
      if (settings['allow_checkbox_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_CHECKBOX_DISCLAIMER = isTrue(settings['allow_checkbox_disclaimer'])
      }
      if (settings['allow_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_DISCLAIMER = isTrue(settings['allow_disclaimer'])
      }
      if (settings['allow_dl_or_ssn'] !== undefined) {
        store.state.configs.ALLOW_DL_OR_SSN = isTrue(settings['allow_dl_or_ssn'])
        store.state.allow_dl_or_ssn = isTrue(settings['allow_dl_or_ssn'])
      }
      if (settings['allow_gopass_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_GOPASS_DISCLAIMER = isTrue(settings['allow_gopass_disclaimer'])
      }
      if (settings['allow_gopass_signature_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_GOPASS_SIGNATURE_DISCLAIMER = isTrue(settings['allow_gopass_signature_disclaimer'])
      }
      if (settings['allow_billing'] !== undefined) {
        store.state.configs.ALLOW_BILLING = isTrue(settings['allow_billing'])
      }
      if (settings['allow_kit_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_KIT_DISCLAIMER = isTrue(settings['allow_kit_disclaimer'])
      }
      if (settings['allow_payment'] !== undefined) {
        store.state.configs.ALLOW_PAYMENT = isTrue(settings['allow_payment'])
      }
      if (settings['allow_results_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_RESULTS_DISCLAIMER = isTrue(settings['allow_results_disclaimer'])
      }
      if (settings['allow_schedules'] !== undefined) {
        store.state.configs.ALLOW_SCHEDULES = isTrue(settings['allow_schedules'])
      }
      if (settings['allow_signature'] !== undefined) {
        store.state.configs.ALLOW_SIGNATURE = isTrue(settings['allow_signature'])
      }
      if (settings['allow_signature_consent'] !== undefined) {
        store.state.configs.ALLOW_SIGNATURE_CONSENT = isTrue(settings['allow_signature_consent'])
      }
      if (settings['allow_signature_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_SIGNATURE_DISCLAIMER = isTrue(settings['allow_signature_disclaimer'])
      }
      if (settings['allow_signature_kit_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_SIGNATURE_KIT_DISCLAIMER = isTrue(settings['allow_signature_kit_disclaimer'])
      }
      if (settings['allow_signature_results_disclaimer'] !== undefined) {
        store.state.configs.ALLOW_SIGNATURE_RESULTS_DISCLAIMER = isTrue(settings['allow_signature_results_disclaimer'])
      }
      if (settings['allow_site_payment'] !== undefined) {
        store.state.configs.ALLOW_SITE_PAYMENT = isTrue(settings['allow_site_payment'])
      }
      if (settings['allow_telehealth'] !== undefined) {
        store.state.configs.ALLOW_TELEHEALTH = isTrue(settings['allow_telehealth'])
      }
      if (settings['allow_uninsured_dl_or_ssn'] !== undefined) {
        store.state.configs.ALLOW_UNINSURED_DL_OR_SSN = isTrue(settings['allow_uninsured_dl_or_ssn'])
      }
      if (settings['at_home_collection'] !== undefined) {
        store.state.configs.AT_HOME_COLLECTION = isTrue(settings['at_home_collection'])
      }
      if (settings['at_home_collection_fee'] !== undefined) {
        store.state.configs.AT_HOME_COLLECTION_FEE = settings['at_home_collection_fee']
      }
      if (store.state.configs.AT_HOME_COLLECTION_FEE === undefined) {
        store.state.configs.AT_HOME_COLLECTION_FEE = false
      }
      if (settings['consent_name_text']) {
        store.state.configs.CONSENT_NAME_TEXT = settings['consent_name_text']
      }
      if (settings['consent_name_text_requirement'] !== undefined) {
        store.state.configs.CONSENT_NAME_TEXT_REQUIREMENT = isTrue(settings['consent_name_text_requirement'])
      }
      if (settings['disclaimer_name_text']) {
        store.state.configs.DISCLAIMER_NAME_TEXT = settings['disclaimer_name_text']
      }
      if (settings['disclaimer_name_text_requirement'] !== undefined) {
        store.state.configs.DISCLAIMER_NAME_TEXT_REQUIREMENT = isTrue(settings['disclaimer_name_text_requirement'])
      }
      if (settings['display_kit_number_on_results'] !== undefined) {
        store.state.configs.DISPLAY_KIT_NUMBER_ON_RESULTS = isTrue(settings['display_kit_number_on_results'])
      }
      if (settings['display_order_barcode'] !== undefined) {
        store.state.configs.DISPLAY_ORDER_BARCODE = isTrue(settings['display_order_barcode'])
      }
      if (settings['dl_or_ssn_required_by_client'] !== undefined) {
        store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT = isTrue(settings['dl_or_ssn_required_by_client'])
        store.state.dl_or_ssn_required_by_client = isTrue(settings['dl_or_ssn_required_by_client'])
      }
      if (settings['double_entry_email'] !== undefined) {
        store.state.configs.DOUBLE_ENTRY_EMAIL = isTrue(settings['double_entry_email'])
      }
      if (settings['enable_guardian_info'] !== undefined) {
        store.state.configs.ENABLE_GUARDIAN_INFO = isTrue(settings['enable_guardian_info'])
      }
      if (settings['force_payment_on_registration'] !== undefined) {
        store.state.configs.FORCE_PAYMENT_ON_REGISTRATION = isTrue(settings['force_payment_on_registration'])
      }
      if (store.state.configs.FORCE_PAYMENT_ON_REGISTRATION === undefined) {
        store.state.configs.FORCE_PAYMENT_ON_REGISTRATION = false
      }
      if (settings['force_valid_address'] !== undefined) {
        store.state.configs.FORCE_VALID_ADDRESS = isTrue(settings['force_valid_address'])
      }
      if (settings['gopass_disclaimer_name_text']) {
        store.state.configs.GOPASS_DISCLAIMER_NAME_TEXT = settings['gopass_disclaimer_name_text']
      }
      if (settings['hide_pay_at_collection'] !== undefined) {
        store.state.configs.HIDE_PAY_AT_COLLECTION = isTrue(settings['hide_pay_at_collection'])
      }
      if (settings['hide_pay_with_card'] !== undefined) {
        store.state.configs.HIDE_PAY_WITH_CARD = isTrue(settings['hide_pay_with_card'])
      }
      if (settings['inline_disclaimer_and_consent'] !== undefined) {
        store.state.configs.INLINE_DISCLAIMER_AND_CONSENT = isTrue(settings['inline_disclaimer_and_consent'])
      }
      if (settings['patient_support_info']) {
        store.state.configs.PATIENT_SUPPORT_INFO = settings['patient_support_info']
      }
      if (settings['payment_amount']) {
        store.state.configs.PAYMENT_AMOUNT = settings['payment_amount']
      }
      if (settings['required_uninsured_dl_or_ssn'] !== undefined) {
        store.state.configs.REQUIRED_UNINSURED_DL_OR_SSN = isTrue(settings['required_uninsured_dl_or_ssn'])
      }
      if (settings['required_uninsured_dl_picture'] !== undefined) {
        store.state.configs.REQUIRED_UNINSURED_DL_PICTURE = isTrue(settings['required_uninsured_dl_picture'])
      }
      if (settings['restrict_insurance_by_icd'] !== undefined) {
        store.state.configs.RESTRICT_INSURANCE_BY_ICD = isTrue(settings['restrict_insurance_by_icd'])
      }
      if (settings['restrict_insurance_by_icd_message']) {
        store.state.configs.RESTRICT_INSURANCE_BY_ICD_MESSAGE = settings['restrict_insurance_by_icd_message']
      }
      if (settings['schedule_month_limit']) {
        store.state.configs.SCHEDULE_MONTH_LIMIT = settings['schedule_month_limit']
      }
      if (settings['scrollbar_disclaimer_consent'] !== undefined) {
        store.state.configs.SCROLLBAR_DISCLAIMER_CONSENT = isTrue(settings['scrollbar_disclaimer_consent'])
      }
      if (settings['security_code_by_email'] !== undefined) {
        store.state.configs.SECURITY_CODE_BY_EMAIL = isTrue(settings['security_code_by_email'])
      }
      if (settings['security_code_by_text'] !== undefined) {
        store.state.configs.SECURITY_CODE_BY_TEXT = isTrue(settings['security_code_by_text'])
      }
      if (settings['show_address_disclaimer'] !== undefined) {
        store.state.configs.SHOW_ADDRESS_DISCLAIMER = isTrue(settings['show_address_disclaimer'])
      }
      if (settings['show_address_disclaimer'] !== undefined) {
        store.state.configs.SHOW_ADDRESS_DISCLAIMER = isTrue(settings['show_address_disclaimer'])
      }
      if (settings['show_dl_barcode_scan'] !== undefined) {
        store.state.configs.SHOW_DL_BARCODE_SCAN = isTrue(settings['show_dl_barcode_scan'])
      }
      if (settings['skip_security_code'] !== undefined) {
        store.state.configs.SKIP_SECURITY_CODE = isTrue(settings['skip_security_code'])
      }
      if (settings['requisition_scheduling'] !== undefined) {
        store.state.configs.REQUISITION_SCHEDULING = isTrue(settings['requisition_scheduling'])
      }
    },
    checkRequirement (name) {
      return store.state.requirements[name] ? (store.state.requirements[name]['required_portal'] === '1' || store.state.requirements[name]['required_portal'] === 1) : false
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/SiteConfigurations.js